/*! For license information please see index.js.LICENSE.txt */
(function () {
  "use strict";

  var e = {
      525: function _(e) {
        var t = Object.getOwnPropertySymbols,
          r = Object.prototype.hasOwnProperty,
          n = Object.prototype.propertyIsEnumerable;
        function o(e) {
          if (null == e) throw new TypeError("Object.assign cannot be called with null or undefined");
          return Object(e);
        }
        e.exports = function () {
          try {
            if (!Object.assign) return !1;
            var e = new String("abc");
            if (e[5] = "de", "5" === Object.getOwnPropertyNames(e)[0]) return !1;
            for (var t = {}, r = 0; r < 10; r++) {
              t["_" + String.fromCharCode(r)] = r;
            }
            if ("0123456789" !== Object.getOwnPropertyNames(t).map(function (e) {
              return t[e];
            }).join("")) return !1;
            var n = {};
            return "abcdefghijklmnopqrst".split("").forEach(function (e) {
              n[e] = e;
            }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, n)).join("");
          } catch (e) {
            return !1;
          }
        }() ? Object.assign : function (e, i) {
          for (var a, u, c = o(e), f = 1; f < arguments.length; f++) {
            for (var l in a = Object(arguments[f])) {
              r.call(a, l) && (c[l] = a[l]);
            }
            if (t) {
              u = t(a);
              for (var s = 0; s < u.length; s++) {
                n.call(a, u[s]) && (c[u[s]] = a[u[s]]);
              }
            }
          }
          return c;
        };
      },
      426: function _(e, t, r) {
        r(525);
        var n = r(378),
          o = 60103;
        if (t.Fragment = 60107, "function" == typeof Symbol && Symbol.for) {
          var i = Symbol.for;
          o = i("react.element"), t.Fragment = i("react.fragment");
        }
        var a = n.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,
          u = Object.prototype.hasOwnProperty,
          c = {
            key: !0,
            ref: !0,
            __self: !0,
            __source: !0
          };
        function f(e, t, r) {
          var n,
            i = {},
            f = null,
            l = null;
          for (n in void 0 !== r && (f = "" + r), void 0 !== t.key && (f = "" + t.key), void 0 !== t.ref && (l = t.ref), t) {
            u.call(t, n) && !c.hasOwnProperty(n) && (i[n] = t[n]);
          }
          if (e && e.defaultProps) for (n in t = e.defaultProps) {
            void 0 === i[n] && (i[n] = t[n]);
          }
          return {
            $$typeof: o,
            type: e,
            key: f,
            ref: l,
            props: i,
            _owner: a.current
          };
        }
        t.jsx = f, t.jsxs = f;
      },
      535: function _(e, t, r) {
        var n = r(525),
          o = 60103,
          i = 60106;
        t.Fragment = 60107, t.StrictMode = 60108, t.Profiler = 60114;
        var a = 60109,
          u = 60110,
          c = 60112;
        t.Suspense = 60113;
        var f = 60115,
          l = 60116;
        if ("function" == typeof Symbol && Symbol.for) {
          var s = Symbol.for;
          o = s("react.element"), i = s("react.portal"), t.Fragment = s("react.fragment"), t.StrictMode = s("react.strict_mode"), t.Profiler = s("react.profiler"), a = s("react.provider"), u = s("react.context"), c = s("react.forward_ref"), t.Suspense = s("react.suspense"), f = s("react.memo"), l = s("react.lazy");
        }
        var p = "function" == typeof Symbol && Symbol.iterator;
        function d(e) {
          for (var t = "https://reactjs.org/docs/error-decoder.html?invariant=" + e, r = 1; r < arguments.length; r++) {
            t += "&args[]=" + encodeURIComponent(arguments[r]);
          }
          return "Minified React error #" + e + "; visit " + t + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
        }
        var y = {
            isMounted: function isMounted() {
              return !1;
            },
            enqueueForceUpdate: function enqueueForceUpdate() {},
            enqueueReplaceState: function enqueueReplaceState() {},
            enqueueSetState: function enqueueSetState() {}
          },
          m = {};
        function v(e, t, r) {
          this.props = e, this.context = t, this.refs = m, this.updater = r || y;
        }
        function h() {}
        function _(e, t, r) {
          this.props = e, this.context = t, this.refs = m, this.updater = r || y;
        }
        v.prototype.isReactComponent = {}, v.prototype.setState = function (e, t) {
          if ("object" != typeof e && "function" != typeof e && null != e) throw Error(d(85));
          this.updater.enqueueSetState(this, e, t, "setState");
        }, v.prototype.forceUpdate = function (e) {
          this.updater.enqueueForceUpdate(this, e, "forceUpdate");
        }, h.prototype = v.prototype;
        var b = _.prototype = new h();
        b.constructor = _, n(b, v.prototype), b.isPureReactComponent = !0;
        var g = {
            current: null
          },
          O = Object.prototype.hasOwnProperty,
          j = {
            key: !0,
            ref: !0,
            __self: !0,
            __source: !0
          };
        function w(e, t, r) {
          var n,
            i = {},
            a = null,
            u = null;
          if (null != t) for (n in void 0 !== t.ref && (u = t.ref), void 0 !== t.key && (a = "" + t.key), t) {
            O.call(t, n) && !j.hasOwnProperty(n) && (i[n] = t[n]);
          }
          var c = arguments.length - 2;
          if (1 === c) i.children = r;else if (1 < c) {
            for (var f = Array(c), l = 0; l < c; l++) {
              f[l] = arguments[l + 2];
            }
            i.children = f;
          }
          if (e && e.defaultProps) for (n in c = e.defaultProps) {
            void 0 === i[n] && (i[n] = c[n]);
          }
          return {
            $$typeof: o,
            type: e,
            key: a,
            ref: u,
            props: i,
            _owner: g.current
          };
        }
        function S(e) {
          return "object" == typeof e && null !== e && e.$$typeof === o;
        }
        var C = /\/+/g;
        function E(e, t) {
          return "object" == typeof e && null !== e && null != e.key ? function (e) {
            var t = {
              "=": "=0",
              ":": "=2"
            };
            return "$" + e.replace(/[=:]/g, function (e) {
              return t[e];
            });
          }("" + e.key) : t.toString(36);
        }
        function k(e, t, r, n, a) {
          var u = typeof e;
          "undefined" !== u && "boolean" !== u || (e = null);
          var c = !1;
          if (null === e) c = !0;else switch (u) {
            case "string":
            case "number":
              c = !0;
              break;
            case "object":
              switch (e.$$typeof) {
                case o:
                case i:
                  c = !0;
              }
          }
          if (c) return a = a(c = e), e = "" === n ? "." + E(c, 0) : n, Array.isArray(a) ? (r = "", null != e && (r = e.replace(C, "$&/") + "/"), k(a, t, r, "", function (e) {
            return e;
          })) : null != a && (S(a) && (a = function (e, t) {
            return {
              $$typeof: o,
              type: e.type,
              key: t,
              ref: e.ref,
              props: e.props,
              _owner: e._owner
            };
          }(a, r + (!a.key || c && c.key === a.key ? "" : ("" + a.key).replace(C, "$&/") + "/") + e)), t.push(a)), 1;
          if (c = 0, n = "" === n ? "." : n + ":", Array.isArray(e)) for (var f = 0; f < e.length; f++) {
            var l = n + E(u = e[f], f);
            c += k(u, t, r, l, a);
          } else if (l = function (e) {
            return null === e || "object" != typeof e ? null : "function" == typeof (e = p && e[p] || e["@@iterator"]) ? e : null;
          }(e), "function" == typeof l) for (e = l.call(e), f = 0; !(u = e.next()).done;) {
            c += k(u = u.value, t, r, l = n + E(u, f++), a);
          } else if ("object" === u) throw t = "" + e, Error(d(31, "[object Object]" === t ? "object with keys {" + Object.keys(e).join(", ") + "}" : t));
          return c;
        }
        function R(e, t, r) {
          if (null == e) return e;
          var n = [],
            o = 0;
          return k(e, n, "", "", function (e) {
            return t.call(r, e, o++);
          }), n;
        }
        function P(e) {
          if (-1 === e._status) {
            var t = e._result;
            t = t(), e._status = 0, e._result = t, t.then(function (t) {
              0 === e._status && (t = t.default, e._status = 1, e._result = t);
            }, function (t) {
              0 === e._status && (e._status = 2, e._result = t);
            });
          }
          if (1 === e._status) return e._result;
          throw e._result;
        }
        var $ = {
          current: null
        };
        function x() {
          var e = $.current;
          if (null === e) throw Error(d(321));
          return e;
        }
        var A = {
          ReactCurrentDispatcher: $,
          ReactCurrentBatchConfig: {
            transition: 0
          },
          ReactCurrentOwner: g,
          IsSomeRendererActing: {
            current: !1
          },
          assign: n
        };
        t.Children = {
          map: R,
          forEach: function forEach(e, t, r) {
            R(e, function () {
              t.apply(this, arguments);
            }, r);
          },
          count: function count(e) {
            var t = 0;
            return R(e, function () {
              t++;
            }), t;
          },
          toArray: function toArray(e) {
            return R(e, function (e) {
              return e;
            }) || [];
          },
          only: function only(e) {
            if (!S(e)) throw Error(d(143));
            return e;
          }
        }, t.Component = v, t.PureComponent = _, t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = A, t.cloneElement = function (e, t, r) {
          if (null == e) throw Error(d(267, e));
          var i = n({}, e.props),
            a = e.key,
            u = e.ref,
            c = e._owner;
          if (null != t) {
            if (void 0 !== t.ref && (u = t.ref, c = g.current), void 0 !== t.key && (a = "" + t.key), e.type && e.type.defaultProps) var f = e.type.defaultProps;
            for (l in t) {
              O.call(t, l) && !j.hasOwnProperty(l) && (i[l] = void 0 === t[l] && void 0 !== f ? f[l] : t[l]);
            }
          }
          var l = arguments.length - 2;
          if (1 === l) i.children = r;else if (1 < l) {
            f = Array(l);
            for (var s = 0; s < l; s++) {
              f[s] = arguments[s + 2];
            }
            i.children = f;
          }
          return {
            $$typeof: o,
            type: e.type,
            key: a,
            ref: u,
            props: i,
            _owner: c
          };
        }, t.createContext = function (e, t) {
          return void 0 === t && (t = null), (e = {
            $$typeof: u,
            _calculateChangedBits: t,
            _currentValue: e,
            _currentValue2: e,
            _threadCount: 0,
            Provider: null,
            Consumer: null
          }).Provider = {
            $$typeof: a,
            _context: e
          }, e.Consumer = e;
        }, t.createElement = w, t.createFactory = function (e) {
          var t = w.bind(null, e);
          return t.type = e, t;
        }, t.createRef = function () {
          return {
            current: null
          };
        }, t.forwardRef = function (e) {
          return {
            $$typeof: c,
            render: e
          };
        }, t.isValidElement = S, t.lazy = function (e) {
          return {
            $$typeof: l,
            _payload: {
              _status: -1,
              _result: e
            },
            _init: P
          };
        }, t.memo = function (e, t) {
          return {
            $$typeof: f,
            type: e,
            compare: void 0 === t ? null : t
          };
        }, t.useCallback = function (e, t) {
          return x().useCallback(e, t);
        }, t.useContext = function (e, t) {
          return x().useContext(e, t);
        }, t.useDebugValue = function () {}, t.useEffect = function (e, t) {
          return x().useEffect(e, t);
        }, t.useImperativeHandle = function (e, t, r) {
          return x().useImperativeHandle(e, t, r);
        }, t.useLayoutEffect = function (e, t) {
          return x().useLayoutEffect(e, t);
        }, t.useMemo = function (e, t) {
          return x().useMemo(e, t);
        }, t.useReducer = function (e, t, r) {
          return x().useReducer(e, t, r);
        }, t.useRef = function (e) {
          return x().useRef(e);
        }, t.useState = function (e) {
          return x().useState(e);
        }, t.version = "17.0.2";
      },
      378: function _(e, t, r) {
        e.exports = r(535);
      },
      246: function _(e, t, r) {
        e.exports = r(426);
      }
    },
    t = {};
  function r(n) {
    var o = t[n];
    if (void 0 !== o) return o.exports;
    var i = t[n] = {
      exports: {}
    };
    return e[n](i, i.exports, r), i.exports;
  }
  r.d = function (e, t) {
    for (var n in t) {
      r.o(t, n) && !r.o(e, n) && Object.defineProperty(e, n, {
        enumerable: !0,
        get: t[n]
      });
    }
  }, r.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, r.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  };
  var n = {};
  (function () {
    r.r(n), r.d(n, {
      DEFAULT_VALUES: function DEFAULT_VALUES() {
        return t;
      },
      default: function _default() {
        return o;
      }
    });
    var e = r(246),
      t = {
        size: "60px",
        width: "6px",
        secondaryColor: "#cccccc",
        primaryColor: "#1ecd96",
        animationDuration: "2s",
        animationTimingFunction: "ease-in-out",
        animationDirection: "normal",
        numberOfRotationsInAnimation: 2
      };
    var o = function o(r) {
      var n = r.size,
        o = void 0 === n ? t.size : n,
        i = r.width,
        a = void 0 === i ? t.width : i,
        u = r.secondaryColor,
        c = void 0 === u ? t.secondaryColor : u,
        f = r.primaryColor,
        l = void 0 === f ? t.primaryColor : f,
        s = r.animationDuration,
        p = void 0 === s ? t.animationDuration : s,
        d = r.animationTimingFunction,
        y = void 0 === d ? t.animationTimingFunction : d,
        m = r.animationDirection,
        v = void 0 === m ? t.animationDirection : m,
        h = r.numberOfRotationsInAnimation,
        _ = void 0 === h ? t.numberOfRotationsInAnimation : h;
      return (0, e.jsxs)(e.Fragment, {
        children: [(0, e.jsx)("style", {
          "data-testid": "loading-spin-style",
          children: "\n                @keyframes spin {\n                    0% {\n                        transform: rotate(0deg);\n                    }\n                    100% {\n                        transform: rotate(".concat(360 * _, "deg);\n                    }\n                }\n              ")
        }), (0, e.jsx)("div", {
          "data-testid": "loading-spin",
          style: {
            display: "inline-block",
            borderStyle: "solid",
            borderRadius: "50%",
            animationIterationCount: "infinite",
            animationName: "spin",
            height: o,
            width: o,
            borderWidth: a,
            animationTimingFunction: y,
            animationDirection: v,
            animationDuration: p,
            borderColor: c,
            borderLeftColor: l,
            borderTopColor: l
          }
        })]
      });
    };
  })();
  var o = exports;
  for (var i in n) {
    o[i] = n[i];
  }
  n.__esModule && Object.defineProperty(o, "__esModule", {
    value: !0
  });
})();